import { StatePage } from "@/components/state-page";
import type { TRouteContext } from "@/utils/types";
import { DirectionProvider, Loader, MantineProvider, NumberInput, type MantineColorsTuple } from "@mantine/core";
import { Notifications } from "@mantine/notifications";
import { NavigationProgress } from "@mantine/nprogress";
import { createRootRouteWithContext, Outlet } from "@tanstack/react-router";

export const Route = createRootRouteWithContext<TRouteContext>()({
  component: Component,
  shellComponent: ({ children }) => (
    <DirectionProvider>
      <MantineProvider
        theme={{
          colors: { myColor },
          primaryColor: "myColor",
          cursorType: "pointer",
          fontFamily: "'Inter', 'Noto Sans Arabic', sans-serif",
          defaultRadius: "md",
          components: {
            NumberInput: NumberInput.extend({
              defaultProps: {
                pattern: "\\d*",
              },
            }),
          },
        }}
      >
        {children}
      </MantineProvider>
    </DirectionProvider>
  ),
  pendingComponent: () => (
    <div className="flex h-screen items-center justify-center">
      <Loader size="xl" />
    </div>
  ),
  errorComponent: ({ error, reset }) => (
    <StatePage
      className="h-screen"
      error={error}
      reset={reset}
      resourceType={undefined}
      emptyResourceType={undefined}
    />
  ),
  notFoundComponent: () => (
    <StatePage className="h-screen" isNotFound resourceType={undefined} emptyResourceType={undefined} />
  ),
});

const myColor: MantineColorsTuple = [
  "#fff2e4",
  "#ffe4cf",
  "#fbc79f",
  "#f8a86c",
  "#f68d40",
  "#f57d24",
  "#f57415",
  "#e36609",
  "#c35603",
  "#aa4800",
];

function Component() {
  return (
    <>
      <NavigationProgress />
      <Notifications autoClose={8000} />
      <Outlet />
    </>
  );
}
